<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
	}


	.flex {
		display: flex;
	}

	.flex-row-center {
		justify-content: center;
	}

	.flex-row-between {
		justify-content: space-between;
	}

	.flex-row-end {
		justify-content: flex-end;
	}

	.flex-col-center {
		align-items: center;
	}



	.mr-15 {
		margin: 15px;
	}

	.mr-t15 {
		margin-top: 15px;
	}

	.mr-l15 {
		margin-left: 15px;
	}

	.mr-20 {
		margin: 20px;
	}

	.mr-t20 {
		margin-top: 20px;
	}

	.mr-l20 {
		margin-left: 20px;
	}

	.pad-30 {
		padding: 30px;
	}

	.text-eli {
		width: 100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	.createBtn{
		float: right;
		margin-top: -10px;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue